import { css } from 'lit';

export default css`
  :host {
    display: inline-block;
    font-family: var(--font-family-base, 'Inter, Arial, sans-serif');
  }

  .button-group {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: 1fr;
    align-items: stretch;
    width: 100%;
    background: transparent;
    border-radius: var(--radius-md, 12px);
    color: var(--color-primary-dark, #001d68);
    gap: var(--button-group-gap, 0);
    overflow: hidden;
  }

  ::slotted(studio-button) {
    height: 100%;
    width: 100%;
    margin: 0;
    max-width: none;
    --button-border-left: var(--sm-line, 1.5px);
    --button-border-right: var(--sm-line, 1.5px);
    border-left-width: var(--button-border-left, var(--sm-line, 1.5px));
    border-right-width: var(--button-border-right, var(--sm-line, 1.5px));
  }

  ::slotted(studio-button[position="left"]) {
    --button-radius: var(--radius-md, 12px) 0 0 var(--radius-md, 12px);
    --button-border-right: 0;
    border-right-width: 0;
    --button-border-left: var(--sm-line, 1.5px);
    border-left-width: var(--sm-line, 1.5px);
  }

  ::slotted(studio-button[position="center"]) {
    --button-radius: 0;
    --button-border-right: 0;
    border-right-width: 0;
    --button-border-left: var(--sm-line, 1.5px);
    border-left-width: var(--sm-line, 1.5px);
  }

  ::slotted(studio-button[position="right"]) {
    --button-radius: 0 var(--radius-md, 12px) var(--radius-md, 12px) 0;
    --button-border-right: var(--sm-line, 1.5px);
    border-right-width: var(--sm-line, 1.5px);
    --button-border-left: var(--sm-line, 1.5px);
    border-left-width: var(--sm-line, 1.5px);
  }

  /* Responsive design */
  @media (max-width: 768px) {
    ::slotted(studio-button) {
      --button-radius: var(--radius-md, 12px);
      --button-border-left: var(--sm-line, 1.5px);
      --button-border-right: var(--sm-line, 1.5px);
      border-left-width: var(--sm-line, 1.5px);
      border-right-width: var(--sm-line, 1.5px);
    }
  }
`;